<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M7.77,783.64l0.46,0.91h2.27v0.91l-1.82,0.45v1.36l-0.91,0.45l-0.45,1.36H6.41l-0.46-1.36l-0.91-0.45v-1.36l-1.82-0.45
	v-0.91H5.5l0.45-0.91H7.77z M-4.95,783.64l0.46,0.91h2.27v0.91l-1.82,0.45v1.36l-0.91,0.45l-0.46,1.36h-0.91l-0.45-1.36l-0.91-0.45
	v-1.36l-1.82-0.45v-0.91h2.27l0.45-0.91H-4.95z M10.5,786.36v2.73l-0.91,0.45v-2.95L10.5,786.36z M3.23,786.36l0.91,0.23v1.59H3.23
	V786.36z M-2.23,786.36v1.82h-0.91v-1.59L-2.23,786.36z M-9.5,786.36l0.91,0.23v2.95l-0.91-0.45V786.36z M1.86,787.73l0.68,1.36
	h3.41v1.36l-2.73,0.68v2.05l-1.36,0.68l-0.68,2.04h-1.36l-0.68-2.04l-1.36-0.68v-2.05l-2.73-0.68v-1.36h3.41l0.68-1.36H1.86z
	 M8.68,788.64v4.09H7.77V790l0.46-0.45v-0.91H8.68z M-7.23,788.64v0.91l0.45,0.45v2.73h-0.91v-4.09H-7.23z M0.5,789.09l-1.36,1.36
	l1.36,1.36l1.36-1.36L0.5,789.09z M5.95,791.82v4.09l-1.36,0.68v-4.43L5.95,791.82z M-4.95,791.82l1.36,0.34v4.43l-1.36-0.68V791.82
	z M3.23,795.23v6.14H1.86v-4.09l0.68-0.68v-1.36H3.23z M-1.55,795.23v1.36l0.68,0.68v4.09h-1.36v-6.14H-1.55z"/>
</svg>

</template>